import ButtonColor from "./ButtonColor";

export default ButtonColor;
